<!-- src/components/ViewChildPopup.vue -->
<template>
    <div class="popup-backdrop"></div>
  <div class="popup-modal">
    <div class="popup-header d-flex justify-content-between align-items-center">
    <h5 class="mb-0" style="margin-top: -8px;">Selected Activities</h5>
      <button class="btn btn-close" style="margin-top: -23px;" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button>
    </div>
    <div class="table-scroll-wrapper">
      <table class=" table-bordered">
        <thead>
          <tr>
            <th
              v-for="(col, index) in mappingColumns.configs"
              :key="index"
              :style="{ textAlign: col.textAlign || 'center' }"
            >
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="displayActivities.length === 0">
            <td :colspan="mappingColumns.configs.length" class="text-center fw-bold py-3">
              No activities selected
            </td>
          </tr>
          <tr v-for="(activity, rowIdx) in editableActivities" :key="rowIdx">
            <td
              v-for="(col, colIdx) in mappingColumns.configs"
              :key="colIdx"
              :style="{ textAlign: col.textAlign || 'center' }"
            >
              <template v-if="col.name === 'Mapping Name'">
                <input
                  type="text"
                  v-model="activity['Mapping Name']"
                  class="form-control"
                  :placeholder="col.label"
                  style="font-size: inherit;"
                  @click.stop
                />
              </template>
              <template v-else>
                {{ activity[col.name] || 'N/A' }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="popup-footer text-center">
      <button class="btn btn-primary" @click="addActivities">Add Activities</button>
      <button class="btn btn-primary" style="
    margin-left: 10px;" @click="submitActivities">Submit</button>
    </div>
  </div>
</template>

<script>
import { pageViews, type } from '@/utils/util';
import { getCookie } from "../../store/cookie.js";
import { makeOpearationRequest } from "@/services/apiServices";
import { toast } from "vue3-toastify"; // <-- add this import

export default {
  name: pageViews.VIEW_CHILD_ACTIVITIES_POPUP,
  props: {
    selectedActivities: {
      type: Array,
      default: () => [],
    },
    childActivityViewData: {
      type: [Array, Object],
      default: null,
    },
    projectParamId: {
      type: String,
      default: "",
    },
    
  },
  data() {
    return {
      mappingColumns: {
        type: type.CHILD_ACTIVITY_VIEW,
        isMultiSelectionAllowed: true,
        defaultSortOrder: { name: "asc", label: "Ascending" },
        defaultSortColumn: { name: "Process", label: "Process" },
        configs: [
          { name: "Use Case Location", label: "Use Case Location", order: 0, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "Use Case", label: "Use Case", order: 1, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "Process Location", label: "Process Location", order: 2, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "Process", label: "Process", order: 3, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "Activity", label: "Activity", order: 4, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "Mapping Name", label: "Mapping Name", order: 5, isSortable: true, defaultSelected: true, textAlign: "left" }
        ]
      },
      editableActivities: [],
    };
  },
  computed: {
    displayActivities() {
      // Use API response if available, else fallback to selectedActivities
      if (Array.isArray(this.childActivityViewData) && this.childActivityViewData.length > 0) {
        return this.childActivityViewData;
      }
      // If API returns object with data property
      if (this.childActivityViewData && Array.isArray(this.childActivityViewData.data)) {
        return this.childActivityViewData.data;
      }
      return this.selectedActivities;
    }
  },
  watch: {
    displayActivities: {
      immediate: true,
      handler(val) {
        // Deep clone to avoid mutating props
        this.editableActivities = (val || []).map(item => ({ ...item }));
      }
    }
  },
  methods: {
    addActivities() {
      this.$emit('add-activities');
    },
    async submitActivities() {
      // Use editableActivities for submission

      // Get Request Id from first row if available, fallback to prop
      let reqId = this.projectParamId;
      if (this.editableActivities && this.editableActivities.length > 0) {
        const firstReqId = this.editableActivities[0]["Request Id"];
        if (firstReqId) {
          reqId = firstReqId;
        }
      }

      const input = (this.editableActivities || []).map(act => ({
        activityId: act["activityId"] || act["Activity Id"] || act["Activity"],
        mappingName: act["mappingName"] || act["Mapping Name"],
        projectParamId: act["Request Id"],
      })).filter(item => item.activityId && item.mappingName);
      if (!input.length) {
        console.error("No valid activities to submit.");
        return;
      }

      const payload = {
        userId: getCookie("userId"),
        type: "mapper.MAPPER_SAVE_CHILD_ACTIVITY",
        requestId: reqId,
        input
      };

      console.log("Submitting child activities payload:", payload);

      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/savedChildActivity", payload);
        console.log("Response from save child activities:", response);
        if (response.status === 200 && response.data ) {
          this.editableActivities = []; // Clear editable activities after successful save
          toast('<i class="fa-solid fa-thumbs-up fa-bounce"></i> Mapping job created successfully.', {
            autoClose: 3000,
            dangerouslyHTMLString: true
          });
          this.$emit('close');
          this.$emit('clear-selection'); // <-- emit clear-selection event
          console.log("Child activities saved successfully", response.data);
        } else {
          toast.error("Failed to save child activities.", {
            autoClose: 5000
          });
        }
      } catch (e) {
        toast.error("Error saving child activities.", {
          autoClose: 5000
        });
      }
    },
  },
};
</script>

<style scoped>
.popup-modal {
  position: fixed;
  top: 7%;
  left: 50%;
  transform: translateX(-50%);
  background: var(--surface);
  width: 93%;
  overflow: hidden;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  max-height: 80vh;
  animation: popupEntry 0.25s ease-out;
}

/* Header */
.popup-header {
  position: sticky;
  top: 0;
  background: var(--surface-highlight);
  padding: 12px 14px;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
}

.popup-header h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.popup-header .btn-close {
  background: none;
  border: none;
  opacity: 0.6;
  transition: opacity 0.2s ease;
  color: var(--text-primary);
}

.popup-header .btn-close:hover {
  opacity: 1;
}

/* Scrollable content */
.table-scroll-wrapper {
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: 55vh;
  padding: 0.5rem 0;
  background: var(--surface);
}

/* Smooth scrollbar */
.table-scroll-wrapper::-webkit-scrollbar {
  width: 8px;
}
.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.15);
  border-radius: 4px;
}

/* Table styling */
table.table-bordered {
  width: 100%;
  table-layout: fixed;
  border-collapse: initial;
  border-radius: 6px;
  overflow: hidden;
}

table.table-bordered thead th {
  background-color: var(--surface-hover);
  color: var(--text-secondary);
  font-weight: 600;
  padding: 12px;
}

table.table-bordered th,
table.table-bordered td {
  white-space: normal;
  word-break: break-word;
  padding: 10px 12px;
  border-color: var(--border-color);
    background: var(--surface);
    color: var(--text-primary);
}

/* Footer */
.popup-footer {
  position: sticky;
  bottom: 0;
  background: var(--surface-highlight);
  padding: 12px 16px;

  border-top: 1px solid var(--border-color);
  text-align: center;
  z-index: 2;
}

/* Buttons */
button.btn-primary {
  background-color: var(--primary) !important;
  padding: 8px 18px;
  border-radius: 6px;
  transition: transform 0.22s ease, background 0.22s ease;
}

button.btn-primary:hover {
  transform: translateY(-2px);
  background-color: #27346f !important;
}

/* Input validation */
.is-invalid {
  border-color: #dc3545 !important;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.85em;
  margin-top: 2px;
}

/* Blurred dark backdrop */
.popup-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 1050;
  animation: backdropFade 0.25s ease-out forwards;
}

.form-control{
  background: var(--body-bg);
  color: var(--text-primary);
}

/* Fade animation */
@keyframes backdropFade {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

/* Popup stays above blurred layer */
.popup-modal {
  z-index: 1051;
}


/* Entry animation */
@keyframes popupEntry {
  0% {
    opacity: 0;
    transform: translate(-50%, -10px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, 0) scale(1);
  }
}

</style>
